<template>
    <div class="border-b border-theme-border w-full pb-4">
        <div>
            <div class="w-full flex justify-between items-center">
                <div class="flex lg:flex-row flex-col">
                    <span>
                        <strong> Fila #&nbsp; {{ error.index }}</strong>
                    </span>
                </div>
                <div class="flex">
                    <app-button
                        :class="
                            isActive ? 'bg-theme-success' : 'bg-theme-disabled'
                        "
                        icon
                        border
                        circle
                        @click="sendActive"
                    >
                        <ChevronUpIcon v-if="isActive" class="w-5 h-5" />
                        <ChevronDownIcon v-else class="w-5 h-5" />
                    </app-button>
                </div>
            </div>
        </div>

        <custom-collapse ref="container mx-auto" :visible="isActive">
            <div class="flex flex-wrap">
                <div
                    v-for="item in base"
                    :key="item.key"
                    class="w-full md:w-1/2 mt-4 flex flex-col"
                >
                    <label
                        class="block text-sm text-theme-muted font-semibold mb-1"
                        >{{ item.name }} :</label
                    >
                    <small class="px-3 text-theme-base">{{
                        error.item[item.key]
                    }}</small>
                </div>
                <div class="w-full mt-3 flex flex-col">
                    <span class="text-lg text-danger"> Errores : </span>
                    <ul>
                        <li v-for="(item, index) in error.reasons" :key="index">
                            {{ item }}
                        </li>
                    </ul>
                </div>
            </div>
        </custom-collapse>
    </div>
</template>

<script>
import ChevronDownIcon from "@/components/icons/ChevronDownIcon.vue";
import ChevronUpIcon from "@/components/icons/ChevronUpIcon.vue";
import CustomCollapse from "@/components/utils/CustomCollapse.vue";

export default {
    name: "ErrorViewer",
    components: { CustomCollapse, ChevronDownIcon, ChevronUpIcon },
    props: {
        error: {
            default: () => ({
                index: 1,
                item: {}
            }),
            type: Object,
            required: true
        },
        active: {
            type: Number,
            default: 0,
            required: false
        },
        base: {
            type: Array,
            default: () => [],
            required: true
        }
    },
    emits: ["changeActive"],
    data: () => ({
        showOptions: false
    }),
    computed: {
        isActive() {
            return this.active === this.error.index;
        }
    },
    mounted() {},
    methods: {
        sendActive() {
            if (this.error.index === this.active) {
                this.$emit("changeActive", 0);
            } else {
                this.$emit("changeActive", this.error.index);
            }
        }
    }
};
</script>
